export default "/images/close-icon-gray.png?b5cf1f12d95caf2616265ed0edb8e251";